import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {MvkInfoList} from '../../model';
import {AccessJson, MvkFilter} from '@amlCore/models';
import {RegistriesService} from '../../service';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {AlertPanelComponent, AlertPanelService, AlertService} from '@amlCore/components';
import {Utils} from '@amlCore/utils';
import {IDataResponse} from '@amlCore/interfaces';
import {
  ResourceService,
  TableService,
  UserService,
  VisitedService
} from '@amlCore/services';
import {DictImportResult} from "../../model/dictImportResult.model";
import {AlertModalComponent, ConfirmComponent, InputFileComponent} from "../../../core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-registry-mvk-info-list',
  templateUrl: './mvkInfoList.component.html'
})
export class MvkInfoListComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  isAll = false;
  loadCheckList = {};
  isActualChecked = false;
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private readonly regSrv: RegistriesService,
              private readonly resourceSrv: ResourceService,
              private readonly userSrv: UserService,
              private readonly modalService: NgbModal,
              protected readonly alertPanelSrv: AlertPanelService,
              protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              private readonly alertSrv: AlertService,
              protected readonly tableService: TableService,
              protected readonly router: Router) {
    super(router, activatedRoute, visitedService, tableService, {
      sort: 'sysRegData',
      dir: 'DESC',
      filter: new MvkFilter()
    });
  }

  dataList: Array<MvkInfoList> = [];
  access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_MVK);
    this.activatedRoute.queryParams.subscribe((data: MvkFilter) => {
      this.loadList(this.syncParams(data));
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data): MvkFilter {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter) as MvkFilter;
  }

  public onPageChange(params) {
    this.navigate(this.getParams(params));
  }

  // @override
  public onSearch() {
    this.customSearch();
  }

  // @override
  public onFilter() {
    this.customSearch();
  }

  public showSubjList(item: MvkInfoList) {
    if(this.isRowInactive(item)) {
      const modal = this.modalService.open(AlertModalComponent);
      modal.componentInstance.text = "Просмотр списка фигурантов решения возможен только по действующему решению";
      return;
    }
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/mvkList', item.id]);
  }

  public remove($event, item: MvkInfoList) {
    this.regSrv.removeFile('/api/v1/cls/extter/mvk/remove',{id: item.id}).subscribe(data => {
      this.alertObjToCheck.open(this.alertPanelSrv.getSuccessMsg(
        `Запись ${item.fileName} удалена!`, true, 10000));
      this.loadList();
    });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  public checkRiskFactor(item: MvkInfoList) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.MVK, this.loadCheckList, this.alertObjToCheck, this.afterCheck.bind(this));
  }

  private afterCheck(item: MvkInfoList, data: any): void {
    if(data.checkDate) {
      const lastCheckedItem = this.dataList.find(d => d.lastChecked && d.id != item.id);
      if(lastCheckedItem){
        lastCheckedItem.lastChecked = false;
      }
    }
  }

  private customSearch() {
    const params = this.getSearchPage(this.filter);
    params['sort'] = 'name';
    params['dir'] = 'ASC';
    params['isAll'] = true;
    const urlParam = {};
    for (const key in params) {
      if (params[key] || typeof params[key] === "number") {
        urlParam[key] = params[key];
      }
    }
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigateByUrl('registries/mvkList?q=' + Utils.encodeJSONBase64(urlParam));
  }

  //обработка результата импорта
  public onAfterImport(result: any) {
    const data = result.data as DictImportResult;
    let comp = result.comp as InputFileComponent;
    let event = result.event;
    if(!data?.success){
      if(data?.needConfirm){
        const modal = this.modalService.open(ConfirmComponent);
        modal.componentInstance.title = "Внимание";
        modal.componentInstance.text = `${data.error} Продолжить импорт?`;
        modal.componentInstance.okBtn = "Да";
        modal.componentInstance.cancelBtn = "Нет";
        modal.componentInstance.hideCloseBtn = true;
        modal.result.then(() => {
          comp.queryParams = comp.queryParams.set("force", "true");
          comp.sendFiles(event.target.files, event, true);
        }, cancel => {
          comp.reset();
        });
      } else {
        comp.reset();
        this.alertObjToCheck.open(this.alertPanelSrv.getErrorMsg(data.error, true, 10000));
      }
    } else {
      comp.reset();
      this.loadList();
      this.alertObjToCheck.open(this.alertPanelSrv.getSuccessMsg(
        `Импортирован справочник ${data.fileName}, импортировано записей ${data.count}.`, true, 10000));

    }
  }

  public loadList(params?: MvkInfoList) {
    const queryParams = this.getParams(params);
    this.resourceSrv.getMvkInfoList(queryParams).subscribe((data: IDataResponse<MvkInfoList>) => {
      this.initIdsMap(data);
      this.dataList = data.content;
      this.total = data.totalSize;
      this.scrollRun();
    });
  }

  isRowInactive(item: MvkInfoList): boolean{
    return !item.isActual && !item.lastChecked;
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }
}
